
import BookingExtraTermsCheckbox from "@/components/bookingflow/steps/extras/BookingExtraTermsCheckbox.vue";
import { ExtraInnerSection } from "@/models/www/ExtrasComponent";
import { defineComponent, PropType } from "vue";

export default defineComponent ({
	components: {
		BookingExtraTermsCheckbox
	},
	props: {
		componentIndex: Number,
		section: {
			type: Object as PropType<ExtraInnerSection>
		} 
	}
})
